import { TextNotesStatus } from "../../../../enums/textNotesStatus";

export const getTextColorForTextNotesStatus = (status: TextNotesStatus) => {
  if (status === TextNotesStatus.NOT_INITIATED) return "#F5F5F5";
  if (status === TextNotesStatus.INITIATED) return "#665D00";
  if (status === TextNotesStatus.IN_PROGRESS) return "#7B1FA2";
  if (status === TextNotesStatus.NOT_APPLICABLE) return "#111111";
  if (status === TextNotesStatus.UPLOADED_UNSIGNED) return "#0056D6";
  if (status === TextNotesStatus.COMPLETED) return "#005D49";
  if (status === TextNotesStatus.FAILED) return "#CC0300";
  return "#F5F5F5";
};
export const getBgColorForTextNotesStatus = (status: TextNotesStatus) => {
  if (status === TextNotesStatus.NOT_INITIATED) return "#111111";
  if (status === TextNotesStatus.INITIATED) return "#FFFCD6";
  if (status === TextNotesStatus.IN_PROGRESS) return "#F3E5F5";
  if (status === TextNotesStatus.NOT_APPLICABLE) return "#F5F5F5";
  if (status === TextNotesStatus.UPLOADED_UNSIGNED) return "#E6F0FF";
  if (status === TextNotesStatus.COMPLETED) return "#E6F3F0";
  if (status === TextNotesStatus.FAILED) return "#FFE8E8";
  return "#111111";
};

export const getTextForTextNotesStatus = (status: TextNotesStatus) => {
  if (status === TextNotesStatus.NOT_INITIATED) return "Not Started";
  if (status === TextNotesStatus.INITIATED) return "Started";
  if (status === TextNotesStatus.IN_PROGRESS) return "In Progress";
  if (status === TextNotesStatus.NOT_APPLICABLE) return "Manual";
  if (status === TextNotesStatus.UPLOADED_UNSIGNED) return "Unsigned";
  if (status === TextNotesStatus.COMPLETED) return "Signed";
  if (status === TextNotesStatus.FAILED) return "Error";
  return "Not Started";
};

export const getTextNotesStatus = (
  status: string,
): { text: string; color: string; bgColor: string } => {
  if (status === TextNotesStatus.NOT_APPLICABLE) {
    return {
      text: getTextForTextNotesStatus(TextNotesStatus.NOT_APPLICABLE),
      color: getTextColorForTextNotesStatus(TextNotesStatus.NOT_APPLICABLE),
      bgColor: getBgColorForTextNotesStatus(TextNotesStatus.NOT_APPLICABLE),
    };
  }
  if (status === TextNotesStatus.UPLOADED_UNSIGNED) {
    return {
      text: getTextForTextNotesStatus(TextNotesStatus.UPLOADED_UNSIGNED),
      color: getTextColorForTextNotesStatus(TextNotesStatus.UPLOADED_UNSIGNED),
      bgColor: getBgColorForTextNotesStatus(TextNotesStatus.UPLOADED_UNSIGNED),
    };
  }
  if (status === TextNotesStatus.COMPLETED) {
    return {
      text: getTextForTextNotesStatus(TextNotesStatus.COMPLETED),
      color: getTextColorForTextNotesStatus(TextNotesStatus.COMPLETED),
      bgColor: getBgColorForTextNotesStatus(TextNotesStatus.COMPLETED),
    };
  }
  if (status === TextNotesStatus.FAILED) {
    return {
      text: getTextForTextNotesStatus(TextNotesStatus.FAILED),
      color: getTextColorForTextNotesStatus(TextNotesStatus.FAILED),
      bgColor: getBgColorForTextNotesStatus(TextNotesStatus.FAILED),
    };
  }
  if (status === TextNotesStatus.NOT_INITIATED) {
    return {
      text: getTextForTextNotesStatus(TextNotesStatus.NOT_INITIATED),
      color: getTextColorForTextNotesStatus(TextNotesStatus.NOT_INITIATED),
      bgColor: getBgColorForTextNotesStatus(TextNotesStatus.NOT_INITIATED),
    };
  }
  if (status === TextNotesStatus.INITIATED) {
    return {
      text: getTextForTextNotesStatus(TextNotesStatus.INITIATED),
      color: getTextColorForTextNotesStatus(TextNotesStatus.INITIATED),
      bgColor: getBgColorForTextNotesStatus(TextNotesStatus.INITIATED),
    };
  }
  if (status === TextNotesStatus.IN_PROGRESS) {
    return {
      text: getTextForTextNotesStatus(TextNotesStatus.IN_PROGRESS),
      color: getTextColorForTextNotesStatus(TextNotesStatus.IN_PROGRESS),
      bgColor: getBgColorForTextNotesStatus(TextNotesStatus.IN_PROGRESS),
    };
  }

  return {
    text: "Not Started",
    color: "#F5F5F5",
    bgColor: "#111111",
  };
};
